import styled from '@emotion/styled';

const SelectedSchoolLabel = styled('strong')({
  fontWeight: 500,
});

export default SelectedSchoolLabel;
